import React from "react";
export const sectionStyle = {
  padding: "28px 30px",
  borderRadius: "26px",
  background: "linear-gradient(180deg, rgba(9,30,52,0.82) 0%, rgba(4,14,27,0.94) 100%)",
  border: "1px solid rgba(99, 229, 255, 0.15)",
  boxShadow: "0 18px 70px rgba(0,0,0,0.16)",
};

export const heading = {
  fontSize: "1.28rem",
  fontWeight: 820,
  letterSpacing: "-0.022em",
  lineHeight: 1.2,
  marginBottom: "10px",
};

export const body = {
  color: "#d2e7f2",
  lineHeight: 1.82,
  fontSize: "1.02rem",
};

export const list = {
  margin: "14px 0 0 20px",
  padding: 0,
  color: "#d2e7f2",
  lineHeight: 1.85,
  fontSize: "1.02rem",
};

export function LegalSection({ title, children }) {
  return (
    <div className="matrixos-glow-card" style={sectionStyle}>
      <div style={heading}>{title}</div>
      <div style={body}>{children}</div>
    </div>
  );
}
